import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { IRange, TYPE_DATE } from 'features/range-date/date-range-picker'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import CloseIcon from 'shared/icons/close_icon.svg'
import { showWrongDateFormat } from 'shared/lib/dateFormat'
import { Input } from 'shared/ui/input'

import s from './styles.module.scss'

interface Props {
  showResetIcon?: boolean
  dateFormat?: DATE_FORMAT_LIST
  placeholders?: {
    from?: string
    to?: string
  }
  selected: IRange | null
  onResetValue: (type: TYPE_DATE) => void
}

const CloseIconCom = ({
  onClick,
  disabled,
}: {
  onClick: () => void
  disabled: boolean
}) => {
  if (!disabled) return null

  return (
    <div
      className={s.closeIcon}
      onClick={() => disabled && onClick()}
    >
      <img
        src={CloseIcon}
        alt=""
      />
    </div>
  )
}

export const CalendarHeader: FC<Props> = ({
  showResetIcon = true,
  dateFormat = DATE_FORMAT_LIST.DAY_MONTH_FULL,
  selected,
  placeholders,
  onResetValue,
}) => {
  const { t } = useTranslation()

  const disableReturnCross = selected?.startDate && selected.endDate

  return (
    <div className={s.container}>
      <div className={clsx(s.input, !selected?.startDate && s.active)}>
        <Input
          showBorder={false}
          readOnly
          style={{ height: 44, padding: 12 }}
          value={showWrongDateFormat(
            selected?.startDate || '',
            dateFormat,
            undefined,
          )}
          placeholder={placeholders?.from || t('when')}
          rightIcon={
            showResetIcon && (
              <CloseIconCom
                disabled={!!selected?.startDate}
                onClick={() => onResetValue(TYPE_DATE.START_DATE)}
              />
            )
          }
        />
      </div>

      <div
        className={clsx(
          s.input,
          selected?.startDate && !selected?.endDate && s.active,
        )}
      >
        <Input
          showBorder={false}
          readOnly
          style={{ height: 44, padding: 12 }}
          value={showWrongDateFormat(
            selected?.endDate || '',
            dateFormat,
            undefined,
          )}
          placeholder={placeholders?.to || t('return')}
          rightIcon={
            showResetIcon && (
              <CloseIconCom
                disabled={!!disableReturnCross}
                onClick={() => onResetValue(TYPE_DATE.END_DATE)}
              />
            )
          }
        />
      </div>
    </div>
  )
}
